import styled from "styled-components";

export const TutorialsWrapper = styled.div`
    padding-top: 5.80rem;
    background-color: var(--bgSecondary);
    .pg-title {
        background-color: var(--white);
        border-bottom: 1px solid var(--border);
    }
    .tutorial-vid {
        max-width: 1050px;
        max-height: 520px;
    }
    .tutorial-vid {
        max-width: 850px;
    }
    body.rtl & {
        .ratio > * {
            left: unset;
            right: 0;
        }
    }
    .content-box {
        background-color: var(--white);
        border-radius: 12px;
    }
    
`